module.exports = __webpack_public_path__ + "static/wave_background-6892455fca1322609d062b7f18cc5a19.png";